import React, { useState, useCallback } from 'react';
import { GoogleMap, useLoadScript, Marker } from '@react-google-maps/api';
import axios from 'axios';
import './locationtracking.css'; // Import the CSS file
import MarketingdashboardAside from './MarketingdashboardAside';

const containerStyle = { width: '100%', height: '400px' };
const defaultCenter = { lat: 20.5937, lng: 78.9629 }; // Default: India
const defaultZoom = 5; // Zoom out view

const Tracking = () => {
  const [empId, setEmpId] = useState('');
  const [mapCenter, setMapCenter] = useState(defaultCenter);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [address, setAddress] = useState('');

  // Load Google Maps
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: 'AIzaSyBn7x8SgnNKsuLWLfsTyEU3oConDa6LaVo', // Replace with your API Key
  });

  const getGeocodeAddress = async (latitude, longitude) => {
    try {
      const response = await axios.get(
        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=AIzaSyBn7x8SgnNKsuLWLfsTyEU3oConDa6LaVo`
      );

      if (response.data.status === 'OK' && response.data.results.length > 0) {
        return response.data.results[0].formatted_address;
      }
      return '';
    } catch (error) {
      return 'Unable to fetch address.';
    }
  };

  const handleTrackLocation = useCallback(async () => {
    if (!empId.trim()) {
      setErrorMessage('Please enter an Employee ID.');
      return;
    }

    setLoading(true);
    setErrorMessage('');

    try {
      const response = await axios.get(`https://cleezoclass.com:8443/api/location/${empId}`);
      if (response.data?.latitude && response.data?.longitude) {
        const location = {
          lat: parseFloat(response.data.latitude),
          lng: parseFloat(response.data.longitude),
        };

        setSelectedLocation(location);
        setMapCenter(location);

        const fetchedAddress = await getGeocodeAddress(location.lat, location.lng);
        setAddress(fetchedAddress);
      } else {
        setErrorMessage('No valid location data found.');
        resetMap();
      }
    } catch (error) {
      setErrorMessage('Error fetching location. Please try again.');
      resetMap();
    } finally {
      setLoading(false);
    }
  }, [empId]);

  const resetMap = useCallback(() => {
    setSelectedLocation(null);
    setMapCenter(defaultCenter);
    setAddress('');
  }, []);

  if (loadError) return <div>Error loading Google Maps.</div>;
  if (!isLoaded) return <div>Loading map...</div>;

  return (
    <div className="tracking-container mainBlock">
      <MarketingdashboardAside />
      <h2 className="tracking-header">Location Tracking</h2>

      <div className="tracking-form">
        <label>
          Employee ID:
          <input
            type="text"
            value={empId}
            onChange={(e) => setEmpId(e.target.value)}
            placeholder="Enter Employee ID"
            className="tracking-input"
          />
        </label>
        <button
          onClick={handleTrackLocation}
          className="tracking-button"
          disabled={loading}
        >
          {loading ? 'Tracking...' : 'Track Location'}
        </button>
      </div>

      {errorMessage && <div className="tracking-error">{errorMessage}</div>}
      {selectedLocation && <div className="tracking-address"><strong>Address:</strong> {address}</div>}

      <div className="tracking-map">
        <GoogleMap mapContainerStyle={containerStyle} center={mapCenter} zoom={selectedLocation ? 15 : defaultZoom}>
          {selectedLocation && <Marker position={selectedLocation} />}
        </GoogleMap>
      </div>
    </div>
  );
};

export default Tracking;
